import React from 'react'
import { getFullFileUrl } from '../../../utils/formatData'

import IconBack from '../../../assets/icons/arrow-back-black.svg'

const RestaurantInfo = ({ restaurantInfo, backToList }) => {
    const { restaurantName, bannerPath, logoPath } = restaurantInfo || {}

    return (
        <div className="restaurant-info">
            <div className="banner">
                <img src={getFullFileUrl(bannerPath)} alt="banner" />
            </div>
            <div className="info container-fluid container-xl">
                <div className="avatar">
                    <img
                        onClick={() => backToList && backToList()}
                        src={getFullFileUrl(logoPath)}
                        alt="banner"
                    />
                </div>
                <div
                    onClick={() => backToList && backToList()}
                    className="name"
                >
                    {restaurantName}
                </div>

               {backToList && (
                   <div className="btn-back" onClick={backToList}>
                        <img
                            width="24px"
                            src={IconBack}
                            alt="icon back"
                        />
                    </div>
               )}
            </div>
        </div>
    )
}

export default RestaurantInfo
